import { render, staticRenderFns } from "./BarcodeSystemCurrentFacilityModal.vue?vue&type=template&id=66340636"
import script from "./BarcodeSystemCurrentFacilityModal.vue?vue&type=script&lang=ts"
export * from "./BarcodeSystemCurrentFacilityModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports